import React from 'react';

import ivyLogo from '../ivy-logo.png';
import gmLogo from '../gm_logo.png';

const Thanks = ({ hotelLogo }) => (
  <div className="panel panel-default thanks">
    {/* <div className="row">
    <div className="col-md-1 col-md-offset-5">
    <img alt="Ivy Logo" src={ivyLogo} height="50"/>       
    </div>
    <div className="col-md-1">
    <img alt="Hotel Logo" src={hotelLogo && hotelLogo !== "" ? hotelLogo : gmLogo} height="50"/>    
    </div>
    <div className="col-md-5"></div>
    </div> */}
    <p>Thanks for submitting your response!</p>
  </div>
);

export default Thanks;
